import { useParams } from "react-router-dom";
import { ModalPageBody, ModalPageCopy, ModalPageWrapper } from "../../../organisms/ModalPage";
import SmokeFreeJourney from "../ProfileBuilderJourneys/SmokeFreeJourney";
import { programmes } from "../../../../enums/programmes";
import useFeatureFlag from "../../../hooks/useFeatureFlag";
import Features from "../../../../enums/features";
import { featureService } from "../../../services";
import { ConfigurableProfileBuilder } from "../ProfileBuilderJourneys/ConfigurableProfileBuilder/ConfigurableProfileBuilder";
import { profileBuilderConfig } from "../../../../configs/serviceConfig";
import { Programmes } from "../../../../data/Programme";

/**
 * Renders profileBuilder journeys for referrals, based on the programme they are in.
 * @returns profileBuilder journey
 */

const ProfileBuilderRoot = () => {
  let { programmeSlug } = useParams();
  const currentProgId = Programmes.find(x => x.slug === programmeSlug)?.programmeId;

  const [configProfileBuilderEnabled, configProfileBuilderReady] = useFeatureFlag(
    Features.CONFIGURABLE_PROFILE_BUILDER,
    featureService.isFeatureEnabled,
    true
  );

  const renderJourney = programmeId => {
    switch (programmeId) {
      case programmes["smoke-free"].id:
        // TODO: this will need to be changed to use actual config once implemented
        // if (builderConfig !== undefined) {
        if (configProfileBuilderEnabled) {
          return <ConfigurableProfileBuilder builderConfig={profileBuilderConfig} />;
        } else {
          return <SmokeFreeJourney />;
        }

      default:
        return (
          <ModalPageWrapper>
            <ModalPageBody>
              <ModalPageCopy>Something went wrong!</ModalPageCopy>
            </ModalPageBody>
          </ModalPageWrapper>
        );
    }
  };

  return <>{renderJourney(currentProgId)}</>;
};

export default ProfileBuilderRoot;
